const imgUrl = [
  require('../../../assets/img/AIDetect/compare/AI (1).png'),
  require('../../../assets/img/AIDetect/compare/AI (2).png'),
  require('../../../assets/img/AIDetect/compare/AI (3).png'),
  require('../../../assets/img/AIDetect/compare/AI (4).png'),
  require('../../../assets/img/AIDetect/compare/AI (5).png'),
];

export default imgUrl;
